import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { asArray } from 'vscode/vscode/vs/base/common/arrays';
import { MarkdownString } from 'vscode/vscode/vs/base/common/htmlContent';

const _moduleId = "vs/workbench/contrib/terminal/browser/terminalTooltip";
function getInstanceHoverInfo(instance) {
    let statusString = '';
    const statuses = instance.statusList.statuses;
    const actions = [];
    for (const status of statuses) {
        statusString += `\n\n---\n\n${status.icon ? `$(${status.icon?.id}) ` : ''}${status.tooltip || status.id}`;
        if (status.hoverActions) {
            actions.push(...status.hoverActions);
        }
    }
    const shellProcessString = getShellProcessTooltip(instance, true);
    const shellIntegrationString = getShellIntegrationTooltip(instance, true);
    const content = ( (new MarkdownString(
        instance.title + shellProcessString + shellIntegrationString + statusString,
        { supportThemeIcons: true }
    )));
    return { content, actions };
}
function getShellIntegrationTooltip(instance, markdown) {
    const shellIntegrationCapabilities = [];
    if (( (instance.capabilities.has(2 )))) {
        shellIntegrationCapabilities.push(2 );
    }
    if (( (instance.capabilities.has(0 )))) {
        shellIntegrationCapabilities.push(0 );
    }
    let shellIntegrationString = '';
    if (shellIntegrationCapabilities.length > 0) {
        shellIntegrationString += `${markdown ? '\n\n---\n\n' : '\n\n'}${( localizeWithPath(_moduleId, 0, "Shell integration activated"))}`;
    }
    else {
        if (instance.shellLaunchConfig.ignoreShellIntegration) {
            shellIntegrationString += `${markdown ? '\n\n---\n\n' : '\n\n'}${( localizeWithPath(
                _moduleId,
                1,
                "The terminal process failed to launch. Disabling shell integration with terminal.integrated.shellIntegration.enabled might help."
            ))}`;
        }
        else {
            if (instance.usedShellIntegrationInjection) {
                shellIntegrationString += `${markdown ? '\n\n---\n\n' : '\n\n'}${( localizeWithPath(_moduleId, 2, "Shell integration failed to activate"))}`;
            }
        }
    }
    return shellIntegrationString;
}
function getShellProcessTooltip(instance, markdown) {
    const lines = [];
    if (instance.processId && instance.processId > 0) {
        lines.push(( localizeWithPath(_moduleId, 3, "Process ID ({0}): {1}", 'PID', instance.processId)) + '\n');
    }
    if (instance.shellLaunchConfig.executable) {
        let commandLine = instance.shellLaunchConfig.executable;
        const args = ( (asArray(instance.injectedArgs || instance.shellLaunchConfig.args || []).map(x => `'${x}'`))).join(' ');
        if (args) {
            commandLine += ` ${args}`;
        }
        lines.push(( localizeWithPath(_moduleId, 4, 'Command line: {0}', commandLine)));
    }
    return lines.length ? `${markdown ? '\n\n---\n\n' : '\n\n'}${lines.join('\n')}` : '';
}

export { getInstanceHoverInfo, getShellIntegrationTooltip, getShellProcessTooltip };
